import { extendTailwindMerge } from 'tailwind-merge';

// Configure tailwind-merge to recognize the 'tw-' prefix
const twMerge = extendTailwindMerge({
  prefix: 'tw-',
});

export default defineNuxtPlugin({
  parallel: true,
  setup(nuxtApp) {
    nuxtApp.vueApp.directive('tw-merge', {
      mounted(el, binding) {
        // Get the classes from binding.value (passed to directive)
        const providedClasses = Array.isArray(binding.value)
          ? binding.value.join(' ')
          : binding.value || '';

        // Merge the provided classes
        const mergedClasses = twMerge(providedClasses);

        el.className = mergedClasses;
      },
      updated(el, binding) {
        const providedClasses = Array.isArray(binding.value)
          ? binding.value.join(' ')
          : binding.value || '';

        const mergedClasses = twMerge(providedClasses);
        el.className = mergedClasses;
      },
    });
  },
});
